import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Table, CardBox,
    DropdownButton, SearchWithAction,
    EmptyState, Page, FormSelect
} from '../../components'
import { retrieve } from '../../actions/project-actions'
import { push } from '../../actions/nav-actions'
import { deleteProject, copyProjectAsStudyCase, fetchORganizationsNames } from '../../api'
import { copy, notify, testRegex, showFile } from '../../utils';
import { Constants } from '../../defaults';
import Loader from '../../components/Loader'

class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: {
                organizations: [],
            },
            search: ''
        };
        this.renderChild = this.renderChild.bind(this);
        this.renderEmpty = this.renderEmpty.bind(this);
    }
    async componentDidMount() {
        const organizations = await fetchORganizationsNames(this.props.user.token);
        this.setState({ organizations: Array.isArray(organizations) ? organizations.map(o => ({ value: o.code, label: o.name })) : [] }, () => {
            this.props.retrieve(this.props.user.token)
        })
    }
    renderEmpty() {
        return (
            <Loader/>
        )
    }
    renderChild() {
        return (
            [
                { Header: 'Project', accessor: 'name' },
                { Header: 'Code', accessor: 'code' },
                {
                    Header: 'Brief Description',
                    accessor: 'description'
                },
                {
                    Header: 'Projected dates',
                    id: 'cellDates',
                    accessor: d => (new Date(d.created_at).toLocaleDateString())
                },
                {
                    Header: 'Organization',
                    accessor: 'organization'
                },
                {
                    Header: 'Country',
                    id: 'cellLocations',
                    accessor: 'geolocation.country'
                },
                {
                    Header: 'Options',
                    accessor: d => d,
                    className: "no-overflow",
                    id: 'options',
                    Cell: props => (
                        <DropdownButton
                            onActionClick={() => {
                                this.props.push(`/projects/${props.value.organization}/${props.value.code}/directory`);
                            }}
                            icon="mdi mdi-account-box"
                            label="Directory">
                            {this.props.user.is_admin && (
                                <DropdownButton.Option
                                    onClick={() => {
                                        let confirm = window.confirm('Really wants to copy project ' + props.value.code + ' as study case?');
                                        if (confirm) {
                                            copyProjectAsStudyCase(this.props.user.token, props.value.organization, props.value.code).then((project) => {
                                                this.props.push('/studycases')
                                            }).catch(err => {
                                                notify(err.message)
                                            })
                                        }

                                    }}
                                    icon="mdi mdi-pencil"
                                    label="Copy as Study Case" />
                            )}
                            <DropdownButton.Option
                                onClick={() => this.props.push(`/projects/${props.value.organization}/${props.value.code}`)}
                                icon="mdi mdi-pencil"
                                label="Edit" />
                            <DropdownButton.Option
                                onClick={() => copy(props.value.code, (text) => notify('Copy code', 'Code [' + text + '] copied!'))}
                                icon="mdi mdi-layers"
                                label="Copy code" />
                            <DropdownButton.Option
                                onClick={() => this.props.push(`/projects/${props.value.organization}/${props.value.code}/members`)}
                                icon="mdi mdi-account-plus"
                                label="Add users" />
                            <DropdownButton.Option
                                onClick={() => {
                                    fetch(`${Constants.API_URL}/v1/me/organizations/${props.value.organization}/projects/${props.value.code}/pdf`, {
                                        headers: {
                                            Authorization: `Baerer ${this.props.user.token}`
                                        }
                                    })
                                        .then(r => r.blob())
                                        .then((blob) => showFile(blob, `${props.value.organization}-${props.value.code}`))
                                }}
                                icon="mdi mdi-download"
                                label="Download PDF" />
                            <DropdownButton.Option
                                onClick={() => {
                                    let confirm = window.confirm('Really wants to delete project ' + props.value.code + '?');
                                    if (confirm) {
                                        deleteProject(this.props.user.token, props.value.organization, props.value.code)
                                            .then((project) => this.props.retrieve(this.props.user.token))
                                            .catch((err) => notify(err.message))
                                    }
                                }}
                                icon="mdi mdi-delete"
                                label="Delete" />
                        </DropdownButton>
                    )
                }
            ]
        )
    }
    render() {
        let results = this.props.projects.data.projects.filter(i => testRegex(i.name, this.state.search));
        if (this.state.query.organizations.length > 0) {
            results = results.filter(u => this.state.query.organizations.indexOf(u.organization) !== -1);
        }
        let leftCol = "";
        let rightCol = "col-12";
        if (this.props.user.is_admin) {
            leftCol = "col-2";
            rightCol = "col-10";
        }
        return (
            <Page title="Projects">
                <div className="row">
                    {this.props.user.is_admin &&
                        <FormSelect
                            className={leftCol}
                            onChange={options => {
                                let { query } = this.state;
                                query.organizations = options ? options.map(o => o.value) : [];
                                this.setState({ query });
                            }}
                            value={this.state.query.organizations}
                            options={this.state.organizations}
                            searchable multi
                            placeholder="Organizations filter" />
                    }
                    <SearchWithAction
                        className={rightCol}
                        action="CREATE PROJET"
                        onActionClick={() => this.props.push('/projects/new')}
                        onChange={search => this.setState({ search })} />
                </div>
                <CardBox>
                    <Table
                        id="projects"
                        renderEmpty={this.renderEmpty}
                        columns={this.renderChild()}
                        data={results} />
                </CardBox>
            </Page>
        )
    }
}


const mapStateToProps = state => ({
    user: state.authReducer.user,
    projects: state.projects
})

const mapDispatchToProps = dispatch => ({
    retrieve(token) {
        dispatch(retrieve(token));
    },
    push(routeName) {
        dispatch(push(routeName));
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(List);


// WEBPACK FOOTER //
// ./src/routers/Projects/List.js